import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { marketingPage, trackMarketing } from "@/lib/marketing";

export default function MarketingAnalytics() {
  const location = useLocation();
  const { lang } = useI18n();

  useEffect(() => {
    if (location.pathname.startsWith("/app") || location.pathname.startsWith("/admin") || location.pathname.startsWith("/share")) return;
    trackMarketing("page_view", { page: marketingPage(location.pathname), language: lang });
  }, [location.pathname, lang]);

  return null;
}
